import { Drawer, List, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import { Link } from "react-router-dom";

export default function Sidebar({ open = true, onClose = null, isModal = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const drawerContent = (
    <>
      <Toolbar>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          MissionTracker
        </Typography>
      </Toolbar>

      <List>
        <ListItemButton
          component={Link}
          to="/"
          sx={{ color: "#fff" }}
          onClick={isModal && isMobile ? onClose : undefined}
        >
          <ListItemIcon><DashboardIcon sx={{ color: "#fff" }} /></ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItemButton>

        <ListItemButton
          component={Link}
          to="/missions"
          sx={{ color: "#fff" }}
          onClick={isModal && isMobile ? onClose : undefined}
        >
          <ListItemIcon><FlagIcon sx={{ color: "#fff" }} /></ListItemIcon>
          <ListItemText primary="Missies" />
        </ListItemButton>

        <ListItemButton
          component={Link}
          to="/persons"
          sx={{ color: "#fff" }}
          onClick={isModal && isMobile ? onClose : undefined}
        >
          <ListItemIcon><PeopleIcon sx={{ color: "#fff" }} /></ListItemIcon>
          <ListItemText primary="Personen" />
        </ListItemButton>
      </List>
    </>
  );

  // On mobile with modal
  if (isModal && isMobile) {
    return (
      <Drawer
        variant="temporary"
        open={open}
        onClose={onClose}
        sx={{
          [`& .MuiDrawer-paper`]: {
            width: 240,
            boxSizing: "border-box",
            bgcolor: "#08084c",
            color: "#fff"
          }
        }}
      >
        {drawerContent}
      </Drawer>
    );
  }

  // On desktop - permanent
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 240,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: 240,
          boxSizing: "border-box",
          bgcolor: "#08084c",
          color: "#fff"
        }
      }}
    >
      {drawerContent}
    </Drawer>
  );
}